/**
 * Web frontend entry (Phase 1). The valuer upload page: sign in -> My uploads -> New
 * upload. Talks to Supabase only for auth; all data flows through the ingestion server
 * (worker/). Styling follows ../DESIGN.md via the tokens in styles/.
 *
 * Fonts are self-hosted (bundled via @fontsource) — no runtime third-party CDN.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@fontsource/dm-sans/500.css';
import '@fontsource/dm-sans/600.css';
import '@fontsource/dm-sans/700.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';

import './styles/tokens.css';
import './styles/app.css';

import { AuthProvider } from './auth';
import { App } from './App';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

createRoot(rootEl).render(
  <StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </StrictMode>,
);
